import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="geburtsdatum"
export default class extends Controller {
	formatieren(event) {
		event.currentTarget.value = this.formattedValue(event.currentTarget.value)
	}

	formattedValue(value) {
		const digits = value.replace(/\D/g, "")
		if (digits.length !== 8) return value

		return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4, 8)}`
	}
}
